personalTree = {
	init() {
		$('.js-personal-tree__filter').find('input, select').on('change', this.reload.bind(this));
	},

	//Перезагрузить окно с параметрами
	reload() {
		let
			$filter = $('.js-personal-tree__filter'),
			params = {},
			searchParams;

		$filter.find('input, select').each(function () {
			var
				$input = $(this),
				key, value;

			key = $input.attr('name');

			if ($input.attr('type') == 'radio')
				value = $filter.find(`[name="${key}"]:checked`).val();

			else value = $input.val();

			if (value != 'false' && value != '0')
				params[key] = value;
		});

		searchParams = new URLSearchParams(params);
		searchParams = searchParams.toString();

		location.href = `${location.protocol}//${location.host}${location.pathname}` + (searchParams && ('?' + searchParams));
	}
}

$(document).ready(function () {
	personalTree.init();
});